import React, { useMemo } from "react";
import { QuestionsIcon } from "../../icons";
import { useConfig } from "../../providers/config_provider";
import SearchQuestion from "../content/question";
import SearchSection from "../section";

export default function SearchSuggestionsQuestions() {
  const { suggestedQuestions, organization } = useConfig();
  const { strings } = organization;
  const { popularQuestionsHeader } = strings;

  const questions = useMemo(() => {
    return (
      suggestedQuestions?.map((question, index) => ({
        ...question,
        rank: index + 1,
        type: "popular_question",
      })) ?? []
    );
  }, [suggestedQuestions]);

  return (
    <SearchSection
      icon={QuestionsIcon}
      title={popularQuestionsHeader}
      meta="questions"
    >
      {questions?.map((question) => (
        <SearchQuestion
          key={question.text}
          question={question}
        />
      ))}
    </SearchSection>
  );
}
